import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator, Mail, Github, Twitter } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { name: 'Calculators', href: '/explore' },
      { name: 'About Us', href: '/about' },
      { name: 'Contact', href: '/contact' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' },
      { name: 'Disclaimer', href: '/disclaimer' }
    ],
    calculators: [
      { name: 'Trigonometry', href: '/calculators/trigonometry' },
      { name: 'Algebra', href: '/calculators/quadratic-solver' },
      { name: 'Geometry', href: '/calculators/circle' },
      { name: 'Calculus', href: '/calculators/derivative' }
    ]
  };

  return (
    <footer className="bg-muted/30 border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center">
                <Calculator className="w-5 h-5 text-primary-foreground" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-lg text-foreground leading-none">VisualMathLab</span>
                <span className="text-xs text-muted-foreground">Learning with Graphs</span>
              </div>
            </Link>
            <p className="text-sm text-muted-foreground mb-4">
              Master mathematics through interactive visualizations and step-by-step solutions.
            </p>
            <div className="flex gap-2">
              <a href="mailto:contact@visualmathlab.online" className="w-9 h-9 rounded-lg bg-muted flex items-center justify-center hover:bg-accent transition-colors">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Product</h3>
            <ul className="space-y-2">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Calculators */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Popular Calculators</h3>
            <ul className="space-y-2">
              {footerLinks.calculators.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Legal</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              © {currentYear} VisualMathLab. All rights reserved.
            </p>
            <p className="text-xs text-muted-foreground text-center md:text-right">
              Made with ❤️ for mathematics education
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}